import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'antd';

import styles from './styles.module.scss';
import NdviIcon from '../../assets/icons/metrics/metric-ndvi.png';
import SoilNdviIcon from '../../assets/icons/metrics/metric-soil-ndvi.png';
import LeafAreaIcon from '../../assets/icons/metrics/metric-leaf-area.png';
import PhotoNdviIcon from '../../assets/icons/metrics/metric-photo-ndvi.png';

import { MetricCard } from './index.jsx';
import { GetMetricsColumnsVegetation } from './libs/index.jsx';
import { getMetricsLabels } from '../../utils/metrics';
import { selectActiveReportChartVegetation } from '../../store/slices/sensors';

const MetricsVegetation = ({ t, sensor, sensorCompared, time, secondaryTime }) => {
  const dispatch = useDispatch();
  const { selectedSecondarySensor, activeReportChartVegetation } = useSelector((state) => state.sensors);
  const [data, setData] = useState([]);
  const noDataLabel = t('empty.noData');
  const MetricsColumns = GetMetricsColumnsVegetation(t);
  const MetricsLabels = getMetricsLabels(t);

  const onClickCard = (id) => {
    dispatch(selectActiveReportChartVegetation(id));
  };

  useEffect(() => {
    if (!sensor || (selectedSecondarySensor && (!sensorCompared || !sensorCompared.id))) return;

    const sensors = selectedSecondarySensor ? [sensor, sensorCompared] : [sensor];
    const dataSource = sensors.reduce((acc, s, index) => {
      if (s) {
        const { id, location, photos, ndvi } = s;

        if (!photos || photos.length === 0) return;

        const ndviValue = ndvi && ndvi.value !== null ? ndvi.value : noDataLabel;

        const timeValue = index === 0 ? time : secondaryTime;

        const dataByTime =
          photos.ndvi && photos.ndvi.length > 0 ? photos.ndvi.filter((item) => item.taken_at === timeValue) : '';
        const dataMaskByTime =
          photos.mask && photos.mask.length > 0 ? photos.mask.filter((item) => item.taken_at === timeValue) : '';
        const ndviMetrics = dataByTime && dataByTime.length > 0 ? dataByTime[0].meta : null;
        const maskMetrics = dataMaskByTime && dataMaskByTime.length > 0 ? dataMaskByTime[0].meta : null;

        const leafNdviValue = ndviMetrics && ndviMetrics.crop_ndvi !== null ? ndviMetrics.crop_ndvi.avg : noDataLabel;
        const soilNdviValue = ndviMetrics && ndviMetrics.soil_ndvi !== null ? ndviMetrics.soil_ndvi.avg : noDataLabel;
        const leafAreaValue = maskMetrics && maskMetrics.ratio !== null ? maskMetrics.ratio : null;

        const leafArea = leafAreaValue !== null ? `${(leafAreaValue * 100).toFixed(1)}%` : noDataLabel;

        acc.push({
          key: `key-${id}`,
          device: location.name || noDataLabel,
          leafNdvi: leafNdviValue,
          leafArea,
          soilNdvi: soilNdviValue,
          ndvi: ndviValue,
          metrics: [
            {
              id: 'leafNdvi',
              label: MetricsLabels.leafNdvi,
              value: leafNdviValue,
              valueSecondary: null,
              icon: NdviIcon,
            },
            {
              id: 'soilNdvi',
              label: MetricsLabels.soilNdvi,
              value: soilNdviValue,
              valueSecondary: null,
              icon: SoilNdviIcon,
            },
            {
              id: 'leafArea',
              label: MetricsLabels.leafArea,
              value: leafArea,
              valueSecondary: null,
              icon: LeafAreaIcon,
            },
            {
              id: `ndvi`,
              label: MetricsLabels.photoNdvi,
              value: ndviValue,
              valueSecondary: null,
              icon: PhotoNdviIcon,
            },
          ],
        });
      }
      return acc;
    }, []);

    setData(dataSource);
  }, [sensor, sensorCompared, selectedSecondarySensor, time, secondaryTime]);

  return (
    <>
      {data && data.length === 1 && (
        <div className={styles.metricsGrid}>
          {data[0] &&
            data[0].metrics &&
            data[0].metrics.map((metric) => {
              return (
                <MetricCard
                  key={metric.id}
                  id={metric.id}
                  label={metric.label}
                  labelMobile={metric.labelMobile || ''}
                  value={metric.value}
                  valueSecondary={metric.valueSecondary}
                  icon={metric.icon}
                  unit={metric.unit}
                  isActive={activeReportChartVegetation === metric.id}
                  clickCard={() => onClickCard(metric.id)}
                  t={t}
                />
              );
            })}
        </div>
      )}

      {/* Two sensors */}
      {data && data.length > 1 && (
        <Table className={styles.metricsTable} columns={MetricsColumns} dataSource={data} pagination={false} />
      )}
    </>
  );
};

export default MetricsVegetation;
